import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import { useNav } from '../../hx/useNav';
import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreMultimedia, isApp } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';


const MxMultimediaList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const size = useWindowSize();
  const [storeMultimedia, setStoreMultimedia] = useSessionStorage('StoreMultimedia', StoreMultimedia);

  const r_list = React.useRef(null);

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    clearStore('StoreMultimedia', storeMultimedia);
    // eslint-disable-next-line
  }, []);

  const hasColumnClient = () => { return Boolean(localStorage.getItem('MxMultimediaList.addcol_txClient') === '1') };
  const hasColumnAnimal = () => { return Boolean(localStorage.getItem('MxMultimediaList.addcol_txAnimal') === '1') };
  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxMultimediaList.addcol_txBranchId') === '1') };

  const openForm = async (op, row) => {

    if (row === null) {
      storeMultimedia.inMultimedia = null;
    } else {
      storeMultimedia.inMultimedia = row.original.inMultimedia;
    }
    setStoreMultimedia(storeMultimedia);

    navTo("multimedia-form");
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inMultimedia", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: "txBranchId", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
        cols.push({ id: id++, Header: trans('field.date'), accessor: "dtMultimedia", highlightDate: true, width: '10%' });
        cols.push({ id: id++, Header: trans('field.type'), accessor: "txTypeMultimedia", highlight: true, width: '15%' });
        cols.push({ id: "txClient", Header: trans('field.client'), accessor: "txClient", highlight: true, width: '20%', show: hasColumnClient() });
        if (isApp('vett') || isApp('spaw')) {
          cols.push({ id: "txAnimal", Header: trans('field.patient'), accessor: "txAnimal", highlight: true, width: '10%', show: hasColumnAnimal() });
        }
        cols.push({ id: id++, Header: trans('field.issue'), accessor: "txIssue", highlight: true, width: '50%' });
        cols.push({ id: id++, Header: trans('field.reference'), accessor: "txReference", highlight: true, width: '25%' });
      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.date'), accessor: "dtMultimedia", highlightDate: true, width: '40%' });
        cols.push({ id: id++, Header: trans('field.issue'), accessor: "txIssue", width: '60%' });
      }

      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["client_dtTo"]), show: false });
      cols.push({ id: "R", Header: "debtor", accessor: row => Boolean(Number(row["client_theBalance"]) < 0), show: false });

    } catch(error) {
      FxLog.errorx('MxMultimediaList.getTableColumns', error)
    }
    return cols;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    cols.push({ id: 'txClient', name: trans('field.client') + " +🔍︎", checked: hasColumnClient() ? '1' : '0' });
    if (isApp('vett') || isApp('spaw')) {
      cols.push({ id: 'txAnimal', name: trans('field.patient') + " +🔍︎", checked: hasColumnAnimal() ? '1' : '0' });
    }
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxMultimediaList.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    localStorage.setItem('MxMultimediaList.addcol_txClient', options.includes('txClient') ? '1' : '0');
    localStorage.setItem('MxMultimediaList.addcol_txAnimal', options.includes('txAnimal') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  const getTooltip = () => {
    let tip = '';
    if (size.isLarge) { // PANTALLA GRANDE
      tip = `${trans('field.date')}`;
      tip = tip + `${' / ' + trans('field.type')}`;
      if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
      if (hasColumnClient()) tip = tip + `${' / ' + trans('field.client')}`;
      if (hasColumnAnimal()) tip = tip + `${' / ' + trans('field.patient')}`;
      tip = tip + `${' / ' + trans('field.issue')}`;
      tip = tip + `${' / ' + trans('field.reference')}`;
      
    } else { // PANTALLA PEQUEÑA
      tip = `${trans('field.date')}`;
      tip = tip + `${' / ' + trans('field.issue')}`;
    }

    return tip;
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.multimedia_files')}`}
        xref={r_list}
        tooltip={getTooltip()}
        fullscreen
        showtip
        url="multimedia"
        //filter={`n_multimedia.txLinkMultimediaTable='n_branch'`}
        onOpenForm={openForm}
        columns={getTableColumns()}
        refColors={[
          `table_cell_color_red|${trans('field.debtor')}`,
          `table_cell_color_gray|${trans('field.inactive')}`,
        ]}
        optionalColumns={getTableOptionalCols()}
        onOptions={optionsSelected}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient theList={r_list} />
          </div>
        }
      />

    </div>
  );

}

export default MxMultimediaList;